import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { debounce } from 'throttle-debounce';
import PropTypes from "prop-types";
import { Form, AutoComplete, Input } from 'antd';
import { SearchOutlined  } from '@ant-design/icons';
import { Rules } from "../../Rules/Rules";
import {
  WrapLabel,
  LabelWrapper,
  HideArrow,
  ErrorMesage
} from "../../../ContributionType/styles";
import {
  AutoSearch,
  OptionsWrapper,
  OptionText,
  OptionDesc,
  SearchInput,
  AssetOutsideWrapLabel
} from './styles';
import {
  updateSelectedTicker,
  changeFundDetails,
  fetchTickerSuggestion,
  clearPrice,
  fetchUnitPrice
} from "../../../../actions";
import { getPrimaryAccount } from '../../../../../../../../utils/sessionUtil'
import TooltipComponent from "../../../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";

const { Option } = AutoComplete;

let searchResults = [];
let tickerSuggestionList = [];
let exactSuggestionList = []
let setSearchField;

let noSearchResult = [];
let setSearchId;
function checkItemExist(data) {
  if(noSearchResult && noSearchResult.indexOf(data) !== -1) {
    return true;
  }
  return false;
}

function removeElement(item) {
  let index = noSearchResult && noSearchResult.indexOf(item);
  if (index > -1) {
    noSearchResult.splice(index, 1);
  }
}

const suffix = (
  <div>
  <SearchOutlined
    style={{
      fontSize: 16
    }}
  />
  &nbsp;Search</div>
);

function checkValidChar(keyCode)
{
  const inValid = [16,17,18,19,20,27,33,34,35,36,37,38,39,40,91,92,93,144,145,
  112,113,114,115,116,117,118,119,120,121,122,123]
  if(inValid.indexOf(keyCode)===-1) 
    return true;
    return false;
}

export class Complete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: [
        {
          fundName: "Vanguard Balanced Index Fund",
          ticker: "VBINX",
          value: "VBINX",
          fundNo: "9912261857",
          fundNumber:"9912261857"
        }
      ],
      result: [],
      isVisible: true,
      searchParam: "",
      suggestionList: [],
      open: false,
      value: '',
      pressed: false
    };
    this.handleSearchDebounced = debounce(500, this.handleSearch);
    this.onDropDownBlur = this.onDropDownBlur.bind(this);
    this.noSearchResultScenario = this.noSearchResultScenario.bind(this);
   }
   handleClickOutside = (event)=>{
    let unique_id = "autoCompleteID" +
    this.props.accountId +
    this.props.contributionType +
    this.props.assetHeld +
    this.props.property +
    this.props.inputId
    let parentElmid = event.target?.parentElement?.getAttribute("data-elem")||event.target?.getAttribute("data-elem")
    if(!(event.target.getAttribute("data-uniqueId") === unique_id || event.target.id === unique_id || parentElmid === "suggesionList"+this.props.property || event.target?.classList?.contains("ant-select-dropdown-menu") || event.target?.classList?.contains("ant-input-suffix") || event?.target?.dataset?.icon === "search"))
      {
        if(this.state.open){
          this.setState({ open:false})
        }
      }
    }

  componentDidMount = () => {
    if (
      this.props.fundDetails &&
      this.props.fundDetails.length !== this.state.source.length
    ) {
      this.setState({ source: this.props.fundDetails });
    }
    let value = {};
    const id =
      "autoCompleteID" +
      this.props.accountId +
      this.props.contributionType +
      this.props.assetHeld +
      this.props.property +
      this.props.inputId;
    value[id] = this.props.value;
    this.props.form.setFieldsValue(value);
    document.addEventListener("mousedown",this.handleClickOutside);
  };
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps = nextProps => {
    const id =
      "autoCompleteID" +
      this.props.accountId +
      this.props.contributionType +
      this.props.assetHeld +
      this.props.property +
      this.props.inputId;
    const elem = document.getElementById(`${"autoSearch_" + id}`);
    let value = {};
    if (
      this.props.assetHeld === nextProps.showErrorMessage.assetHeld &&
      nextProps.showErrorMessage.fund
    ) {
      value[id] = this.props.value;
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
    }
    if (nextProps.value !== this.props.value) {
      if (elem) {
        elem.querySelector(".ant-input").value = nextProps.value;
      }
      value[id] = nextProps.value;
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
      this.setState({ value: nextProps.value });
    }
    if (nextProps.tickerSuggestion !== this.props.tickerSuggestion) {
          this.setState({ suggestionList: nextProps.tickerSuggestion });
          tickerSuggestionList = nextProps.tickerSuggestion;
          exactSuggestionList = nextProps.tickerExactSuggestion
          if (!!tickerSuggestionList && tickerSuggestionList.length === 0) {
            this.setState({ apiFailed: true });
            if( id === setSearchId && !checkItemExist(setSearchId)) {
              noSearchResult.push(setSearchId);
            }
            if (this.props.label === setSearchField) {
              if(nextProps.value) {
                if (elem) {
                  value[id] = elem.querySelector(".ant-input").value
                  this.props.form.setFieldsValue(value);
                }
              }
              this.props.form.validateFields();
            }
          }
          if (!!tickerSuggestionList && tickerSuggestionList.length === 1 && this.state.searchParam === tickerSuggestionList[0].ticker.toUpperCase() && setSearchField === "Ticker symbol") {
            this.setState({open:false})
            this.props.updateTicker(tickerSuggestionList[0], tickerSuggestionList[0].ticker.toUpperCase());
            this.fetchUnitPrice(tickerSuggestionList[0], tickerSuggestionList[0].ticker.toUpperCase());
            tickerSuggestionList = [];
            if(id === setSearchId) {
              if(checkItemExist(setSearchId)) {
                removeElement(setSearchId);
              }
              const otherId =
                "autoCompleteID" +
                this.props.accountId +
                this.props.contributionType +
                this.props.assetHeld +
                `${this.props.contributionType ==="mutualFund" ?  
                    this.props.property === "tickerSymbol" ? "fundName": "tickerSymbol" :
                    this.props.property === "tickerSymbol" ?"securityName" : "tickerSymbol"
                  }`+
                this.props.inputId;
              if(checkItemExist(otherId)) {
                removeElement(otherId);
              }
            }
          }
          this.setState({ isVisible: true }); 
          this.props.updateValue(elem.querySelector(".ant-input").value); 
    }
    if(this.props.completeId !== nextProps.selectedAutoComplete ) {
      if(this.state.open) {
        this.setState({ open:false });
      }
    }
  };

  componentWillUpdate(props) {
    const id =
      "autoCompleteID" +
      this.props.accountId +
      this.props.contributionType +
      this.props.assetHeld +
      this.props.property +
      this.props.inputId;
    const elem = document.getElementById(`${"autoSearch_" + id}`);
    if (elem) {
      elem.querySelector(".ant-input").value = props.value;
    }
  }

  handleSearch = value => {
    let res = [];
    searchResults = [];
    if (value.length) {
      for (let i = 0; i < this.state.source.length; i++) {
        if (this.state.source[i][this.props.controller] &&
          this.state.source[i][this.props.controller]
            .toString()
            .toLowerCase()
            .indexOf(value.toLowerCase()) >= 0
        ) {
          res.push(this.state.source[i]);
        }
      }
    }
    searchResults = res;
    this.setState({ result: res });
  };

  fetchUnitPrice(data, exactTicker) {
    let name;
    if(data.name.indexOf('#%') !== -1) {
      name = data.name.replace('#%', '');
    }
    this.props.fetchUnitPrice({
      metaData: {
        method: "GET",
        url: `/donor-portal/api/contribution/${
          getPrimaryAccount().userId
        }/findRealtimePriceFromMorningStarAPI?ticker=${encodeURIComponent(data.ticker.toUpperCase())
        }&hiddenTicker=${encodeURIComponent(exactTicker)}&name=${
        encodeURIComponent(name)
      }&type=${this.props.contributionType==="mutualFund" ?"mutualfund" : "security"}` ,
        page: "makeAContribution",
        isExternal: false        
      }
    });
  }

  onSelectOption = (value, option) => {
    setSearchField = "";
    if (this.props.assetHeld === "assetOutsideVG") {
      const selectedOption = this.state.suggestionList.filter(
        options => options.ticker === option.key
      );
      const exactTicker = exactSuggestionList && exactSuggestionList.filter(
        options => options.ticker.toLowerCase() === option.key
      );
      const otherId =
        "autoCompleteID" +
        this.props.accountId +
        this.props.contributionType +
        this.props.assetHeld +
        `${this.props.contributionType ==="mutualFund" ?
          this.props.property === "tickerSymbol" ? "fundName": "tickerSymbol" :
          this.props.property === "tickerSymbol" ?"securityName" : "tickerSymbol"
        }`+
        this.props.inputId;
      if(checkItemExist(setSearchId)) {
        removeElement(setSearchId);
      }
      if(checkItemExist(otherId)) {
        removeElement(otherId);
      }
      if (exactTicker && exactTicker.length) {
        this.props.updateTicker(selectedOption[0],exactTicker[0]?.ticker);
      }
      tickerSuggestionList = [];
      setTimeout(() => {
        this.setState({open:false});
      }, 500);
      this.props.form.validateFields();
      if (selectedOption && selectedOption.length && exactTicker && exactTicker.length) {
        this.fetchUnitPrice(selectedOption[0], exactTicker[0] && exactTicker[0].ticker);
      }
    } else {
      const selectedOption = this.state.source.filter(
        options => options.value.toString() === option.key
      );
      this.props.updateTicker(selectedOption[0]);
      searchResults = [];
      this.setState({ result: [] });
    }
  };

  setValue = () => {
    const id =
      "autoCompleteID" +
      this.props.accountId +
      this.props.contributionType +
      this.props.assetHeld +
      this.props.property +
      this.props.inputId;
    const elem = document.getElementById(`${"autoSearch_" + id}`);
    if (elem) {
      elem.querySelector(".ant-input").value = this.props.value;
    }
    searchResults = [];
    this.setState({ result: [] });
    setTimeout(() => {
      this.setState({ suggestionList: [] });
    }, 500);
    tickerSuggestionList = [];
  };

  onDropDownBlur = e => {
    this.setState({ open: false });
    this.props.form.validateFields();
    setSearchField = "";
    if (this.props.value !== e) {
      this.props.updateValue(e);
    }
    this.setState({ suggestionList: [] });
    tickerSuggestionList = [];
  };

  async tickerSearch(e, label, action){
    const id =
    "autoCompleteID" +
    this.props.accountId +
    this.props.contributionType +
    this.props.assetHeld +
    this.props.property +
    this.props.inputId;
    const elem = document.getElementById(`${"autoSearch_" + id}`);
    if (e && e.which === 32 && (elem && elem.querySelector(".ant-input").value.length === 0 || (e?.target?.selectionStart !== e?.target?.selectionEnd && e?.target?.selectionStart ===0 )))
    e.preventDefault();
    if(e && !(e.keyCode === 13)) {
      if(checkItemExist(id)) {
        removeElement(id);
      }
    }
    if(checkValidChar(e?.keyCode))
    {
      this.props.clearPrice(this.props.unitPrice)
    }
    if (!((e && e.keyCode === 8) || (e && e.keyCode === 46) || (e && e.keyCode === 37) || (e && e.keyCode === 39)|| (e && e.keyCode === 38) || (e && e.keyCode === 40))){
       this.setState({ suggestionList: [] });
      if (elem) {
        this.setState({ searchParam: elem.querySelector(".ant-input").value });
      }
      if ((action === "click" && elem && !!elem.querySelector(".ant-input").value) || (action === "key" && !!e.target.value && (e.keyCode === 9))) {
        setSearchField = label;
        setSearchId = id;
        if(!checkItemExist(setSearchId)) {
          noSearchResult.push(setSearchId);
        }
        tickerSuggestionList = [];
        this.setState({ isVisible: false });
        if (e.keyCode === 9 || e.keyCode === 13) {
          e.preventDefault();
        }

        await this.props.fetchTickerSuggestion({
          metaData: {
            method: "GET",
            url: `/donor-portal/api/contribution/${
              getPrimaryAccount().userId
            }/findDetailsFromMorningStarAPI?ticker=${this.props.property==="tickerSymbol" ?
            encodeURIComponent(elem.querySelector(".ant-input").value):""
            }&name=${this.props.property!=="tickerSymbol" ?
            encodeURIComponent(elem.querySelector(".ant-input").value):""
          }&type=${this.props.contributionType==="mutualFund" ?"mutualfund" : "security"}` ,
            page: "makeAContribution",
            isExternal: false        
          }
        });
        this.setState({ open: true }, () => {
          this.props.handleOpenAutoComplete(this.props.completeId);
        });
      }
    }  
  };
  
noSearchResultScenario = (rule, value, callback) => {
  if (checkItemExist(rule.field) && value) {
    return callback(
     <ErrorMesage morningStar>
       Please try again. If the {this.props.label === "Ticker symbol"? "ticker": "name"} is correct, continue on. We'll contact you if needed.
     </ErrorMesage>
    );
  }
   else callback();
  };
 
  render() {
    const { getFieldDecorator } = this.props.form;
    const children = searchResults.length
      ? searchResults.map(ticker => (
          <Option
            key={ticker["value"]}
            value={ticker[this.props.controller] ? ticker[this.props.controller].toString() : ""}
          >
            <OptionsWrapper>
              <OptionText>{ticker.ticker.toUpperCase()}</OptionText>
              <OptionDesc>{ticker.fundNo}</OptionDesc>
              <OptionDesc>{ticker.fundName}</OptionDesc>
            </OptionsWrapper>
          </Option>
        ))
      : [];
   const childrenFundName =
    this.state.suggestionList && this.state.suggestionList.length
        ? this.state.suggestionList.map(ticker=> (
            <Option
              key={ticker["ticker"]}
              value={ticker[this.props.controller]}  
            >
              <OptionsWrapper data-elem={`suggesionList${this.props.property}`}>
                <OptionText>{ticker.ticker ? ticker.ticker.toUpperCase():""}</OptionText>
                <OptionDesc>{ticker.name ? ticker.name.replace('#%', ''):""}</OptionDesc>
              </OptionsWrapper>
            </Option>
          ))
        : [];
    return (
      <HideArrow>
        {this.props.assetHeld === "assetOutsideVG" ? (
          <AssetOutsideWrapLabel>
            <Form.Item
              data-test='form-item'
              autocomplete="off"
              colon={false}
              label={<LabelWrapper>{this.props.label}<TooltipComponent text = {this.props.toolTip}/></LabelWrapper>}
            >
              {getFieldDecorator(
                "autoCompleteID" +
                  this.props.accountId +
                  this.props.contributionType +
                  this.props.assetHeld +
                  this.props.property +
                  this.props.inputId,
                {
                  validateTrigger: "onBlur",
                  rules:
                    this.props.property === "tickerSymbol"
                    ? 
                         [ {
                            required: true,
                            message: (
                              <ErrorMesage>
                                Please enter a ticker symbol. For example,
                                Vanguard Total Stock Market Index Fund Admiral
                                Shares ticker is VTSAX.
                              </ErrorMesage>
                            )
                          },
                          {
                            max: 50,
                            message: (
                              <ErrorMesage>
                                Maximum character limit for Ticker Symbol is 50.
                                Please correct to Proceed.
                              </ErrorMesage>
                            )
                          },
                          {
                            validator: this.noSearchResultScenario
                          }
                        ]:[ {
                            required: true,
                            message: <ErrorMesage>Please enter {this.props.label.toLowerCase()}.</ErrorMesage>
                          },
                          {
                            max: 100,
                            message: <ErrorMesage>Maximum character limit for {this.props.label } is 100. Please correct to Proceed.</ErrorMesage>
                          },
                          {
                            validator: this.noSearchResultScenario
                          }],
                        
                       
                  normalize: input =>
                    this.props.property === "tickerSymbol"
                      ? input.toUpperCase()
                      : input.replace('#%', '')
                }
              )(
                <AutoSearch
                  data-test='auto-search'
                  aria-labelledby={this.props.property}
                  role="combobox"
                  autocomplete="off"
                  className="auto_complete assetHeldOutside"
                  disabled={!this.state.isVisible}
                  open={this.state.open}   
                  onInputKeyDown={value =>
                    this.tickerSearch(value, this.props.label, "key")
                  }
                  placeholder={this.props.placeholder}
                  onSelect={this.onSelectOption}
                  onBlur={e => this.onDropDownBlur(e)}
                  onDropdownVisibleChange={() => this.setValue()}
                  dataSource={childrenFundName}
                  dropdownMenuStyle={{ maxHeight: 300 }}
                  onFocus={(e) => {
                    this.props.handleOpenAutoComplete(this.props.completeId)
                  }}
                  defaultActiveFirstOption = {false}
                >
                  <SearchInput
                    autocomplete="off"
                    className="assetOutsideSearchInput"
                    id={"autoCompleteID" +
                    this.props.accountId +
                    this.props.contributionType +
                    this.props.assetHeld +
                    this.props.property +
                    this.props.inputId}
                    enterButton={suffix}
                    size="small"
                    onSearch={value =>
                      this.tickerSearch(value, this.props.label, "click")
                    }
                  />
                </AutoSearch>
              )}
            </Form.Item>
          </AssetOutsideWrapLabel>): (
            <WrapLabel>
              <Form.Item
                colon={false}
                label={<LabelWrapper>{this.props.label}</LabelWrapper>}
              >
                {getFieldDecorator(
                  "autoCompleteID" +
                    this.props.accountId +
                    this.props.contributionType +
                    this.props.assetHeld +
                    this.props.property +
                    this.props.inputId,
                  {
                    validateTrigger: "onBlur",
                    rules: Rules[this.props.property]
                      ? Rules[this.props.property].rules
                      : "",
                    normalize: input =>
                      this.props.property === "tickerSymbol"
                        ? input.toUpperCase()
                        : input
                  }
                )(
                  <AutoSearch
                    aria-labelledby={this.props.property}
                    role="combobox"
                    className="auto_complete"
                    onSearch={this.handleSearchDebounced}
                    placeholder={"Select the " + this.props.label.toLowerCase()}
                    onSelect={this.onSelectOption}
                    onBlur={e => this.onDropDownBlur(e)}
                    onDropdownVisibleChange={() => this.setValue()}
                  >
                    {children}
                  </AutoSearch>
                )}
              </Form.Item>
            </WrapLabel>
        )}
      </HideArrow>
    );
  }
}

const AutoCompleteForm = Form.create({ name: "autoSearch" })(Complete);

AutoCompleteForm.propTypes = {
  fundDetails: PropTypes.array,
  value: PropTypes.string,
  updateTicker: PropTypes.func,
  updateValue: PropTypes.func,
  updateTicker: PropTypes.func,
  updateValue: PropTypes.func,
  fetchUnitPrice: PropTypes.func,
  clearPrice: PropTypes.func,
  fetchTickerSuggestion: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  return {
    fundDetails: state.getIn([
      "makeAContribution",
      "apiData",
      "tickerValues",
      "data"
    ]),
    value: state.getIn([
      "makeAContribution",
      "contributionTypes",
      `${ownProps.assetHeld}`,
      `${ownProps.contributionType}`,
      `${ownProps.accountId}`,
      `${ownProps.fundType}`,
      `${ownProps.inputId}`,
      `${ownProps.property}`
    ]),
    accountInfo: state.getIn([
      "makeAContribution",
      "contributionTypes",
      `${ownProps.assetHeld}`,
      `${ownProps.contributionType}`
    ]),
    showErrorMessage: state.getIn([
      "makeAContribution",
      "contributionTypes",
      "showErrorMessage"
    ]),
    isSecuritySelected: state.getIn([
      "makeAContribution",
      "contributionTypes",
      `${ownProps.assetHeld}`,
      "sgSelected"
    ]),
    tickerSuggestion: state.getIn(["makeAContribution", "tickerSuggestion"]),
    tickerExactSuggestion:state.getIn(["makeAContribution", "tickerExactSuggestion"])
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
  updateTicker: (data,exactTicker) =>
    dispatch(
      updateSelectedTicker({
        value: data,
        hiddenTicker:exactTicker,
        accountId: ownProps.accountId,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld,
        fundType: ownProps.fundType,
        donorId: ownProps.inputId
      })
    ),
  updateValue: e =>
    dispatch(
      changeFundDetails({
        value: e,
        property: ownProps.property,
        inputId: ownProps.inputId,
        accountId: ownProps.accountId,
        fundType: ownProps.fundType,
        contributionType: ownProps.contributionType,
        assetHeld: "autoComplete",
        flag:ownProps.assetHeld
      })
    ),
  fetchUnitPrice: data =>
   dispatch(
    fetchUnitPrice({
        value: data,
        accountId: ownProps.accountId,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld,
        fundType: ownProps.fundType,
        donorId: ownProps.inputId
      })
    ),
    clearPrice: data =>
    dispatch(
      clearPrice({
        value: data,
        accountId: ownProps.accountId,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld,
        fundType: ownProps.fundType,
        donorId: ownProps.inputId
      })
    ),
  fetchTickerSuggestion: data => {
    dispatch(
      fetchTickerSuggestion(
        data
      )
    );
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AutoCompleteForm)
);
